import React, { useEffect, useState } from "react";
import Sidebar from "../layout/Sidebar";
import AppHeader from "../layout/Header";
import MobileTabBar from "../layout/MobileTabBar";
import WelcomePanel from "../layout/WelcomePanel";
import { Outlet } from "react-router-dom";
// import PrivacyGuard from "../PrivacyGuard/PrivacyGuard";

const MOBILE_BREAKPOINT = 992;

const Layout = () => {
  const getIsMobile = () =>
    typeof window !== "undefined" && window.innerWidth < MOBILE_BREAKPOINT;

  const [isMobile, setIsMobile] = useState(getIsMobile);
  const [sidebarOpen, setSidebarOpen] = useState(() => !getIsMobile());

  useEffect(() => {
    const handleResize = () => {
      const nextIsMobile = window.innerWidth < MOBILE_BREAKPOINT;

      setIsMobile((previousIsMobile) => {
        if (previousIsMobile !== nextIsMobile) {
          // Desktop keeps the navigation visible by default, while mobile starts
          // with the off-canvas navigation closed to preserve content space.
          setSidebarOpen(!nextIsMobile);
        }
        return nextIsMobile;
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!isMobile) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = sidebarOpen ? "hidden" : previousOverflow;

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isMobile, sidebarOpen]);

  return (
    <>
      <div
        className={`page-wrapper ${
          !isMobile && !sidebarOpen ? "sidebar-hidden-desktop" : ""
        } ${isMobile && sidebarOpen ? "mobile-sidebar-open" : ""}`}
      >
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

        {isMobile && sidebarOpen && (
          <button
            type="button"
            className="sidebar-backdrop"
            aria-label="Close navigation"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        <div className="main-container">
          <AppHeader
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
          />

          <div className="app-container">
            <Outlet />
          </div>
        </div>

        <MobileTabBar onOpenMore={() => setSidebarOpen(true)} isMoreOpen={isMobile && sidebarOpen} />
      </div>
      <WelcomePanel />
      {/* <PrivacyGuard/> */}
    </>
  );
};

export default Layout;
